import React from 'react';
import '../Colors.css';

const Nearby = ({className, heightStyle}) => {
  return (
    <svg height={heightStyle} viewBox="0 0 283.465 283.632" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path className='HslGreen' d="M141.732,267.341c-36.725,0-71.319-3.473-97.409-9.779C14.913,250.452,0,240.697,0,228.566
        c0-25.321,64.928-34.036,92.843-36.608c3.293-0.306,6.174,2.109,6.476,5.383c0.301,3.275-2.108,6.174-5.383,6.475
        c-24.973,2.301-46.237,6.295-61.494,11.552c-16.208,5.584-20.533,10.923-20.533,13.197c0,0.089,0.402,9.005,35.213,17.419
        c25.2,6.091,58.801,9.446,94.611,9.446s69.41-3.355,94.611-9.446c34.81-8.414,35.213-17.33,35.213-17.419
        c0-2.274-4.324-7.612-20.531-13.197c-15.256-5.257-36.518-9.251-61.489-11.552c-3.275-0.301-5.684-3.201-5.383-6.475
        c0.301-3.275,3.195-5.689,6.476-5.383c27.913,2.572,92.836,11.287,92.836,36.607c0,12.131-14.913,21.886-44.324,28.995
        C213.051,263.868,178.458,267.341,141.732,267.341z"/>
      <path className='Train' d="M170.562,118.61h-2.813v23.207h-52.39V118.61h-2.813l-5.274,35.161c-1.054,4.571-5.274,7.735-9.845,7.735
        c-5.978,0-10.548-4.922-10.548-9.845c0-1.406,0-2.812,0.703-4.219l12.306-55.554c3.516-9.846,8.79-13.362,17.581-13.362h47.467
        c8.79,0,14.416,3.516,17.581,13.362l13.01,55.905c0.351,1.406,0.351,2.813,0.351,4.22c0,4.922-4.219,9.845-10.196,9.845
        c-4.923,0-9.142-3.164-9.846-7.735L170.562,118.61z M141.377,69.736c-14.416,0-26.37-11.955-26.37-26.722
        c0-14.768,11.954-26.723,26.722-26.723c14.415,0,26.371,11.955,26.371,26.723c0,14.767-11.956,26.722-26.371,26.722H141.377z
         M141.377,159.748c-1.758,0-2.813,1.407-2.813,2.813v69.619h-23.207v-85.09h52.39v85.09h-23.207v-69.619
        c0-1.406-1.054-2.813-2.812-2.813H141.377z"/>
    </svg>
  );
};

export default Nearby;